import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: '#159B78',
    color: 'white',
    flexGrow: 1,
    marginRight: '1rem'
  }
}));
